import axios from "axios";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { SHOPIFY_DOMAIN, STORE_FRONT_ACCESS_TOKEN } from "~/utils/constants";

export const productApi = createApi({
  reducerPath: "productApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `https://${SHOPIFY_DOMAIN}/api/2024-07/`,
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      headers.set("X-Shopify-Storefront-Access-Token", STORE_FRONT_ACCESS_TOKEN);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getProduct: builder.query({
      query: (productId) => ({
        url: "graphql.json",
        method: "POST",
        body: {
          query: `
            {
              product(id: "gid://shopify/Product/${productId}") {
                id
                title
                description
                images(first: 5) {
                  edges {
                    node {
                      url
                      altText
                    }
                  }
                }
                variants(first: 5) {
                  edges {
                    node {
                      id
                      title
                      price {
                        amount
                        currencyCode
                      }
                    }
                  }
                }
              }
            }
          `,
        },
      }),
      transformResponse: (response) => response.data.product,
    }),

    getProductByHandle: builder.query({
      queryFn: async (productHandle) => {
        try {
          const response = await axios.get(`https://${SHOPIFY_DOMAIN}/products/${productHandle}`);

          const htmlText = response.data;

          const parser = new DOMParser();
          const dom = parser.parseFromString(htmlText, "text/html");

          const productSectionElement = dom.querySelector('section[id="main-product-section"]');
          const productDetailsDescription = productSectionElement?.querySelector(
            ".product-details__description"
          );

          if (!productDetailsDescription) {
            throw new Error("Product description not found");
          }

          return { data: { description: productDetailsDescription.innerHTML } };
        } catch (error) {
          return { error: { message: error.message } };
        }
      },
    }),
  }),
});

export const { useGetProductQuery, useGetProductByHandleQuery } = productApi;
